export type ColorType = "primary" | "secondary" | "success" | "danger" | "warning" | "info" | "light" | "dark"

export const COLOR_SECONDARY = "var(--secondary-color)"
export const COLOR_SECONDARY_ACTIVE = "var(--secondary-active-color)"

export const COLOR_SUCCESS = "var(--success-color)"
export const COLOR_SUCCESS_ACTIVE = "var(--success-active-color)"
export const COLOR_PRIMARY = "var(--primary-color)"
export const COLOR_MIDDLE_PRIMARY = "var(--primary-middle-color)"
export const COLOR_PRIMARY_ACTIVE = "var(--primary-active-color)"

export const COLOR_WARNING = "var(--warning-color)"
export const COLOR_WARNING_ACTIVE = "var(--warning-active-color)"

export const COLOR_WARNING_STRONG = "var(--warning-strong-color)"
export const COLOR_WARNING_STRONG_ACTIVE = "var(--warning-strong-active-color)"

export const COLOR_BLACK = "var(--black-color)"
export const COLOR_WHITE = "var(--white-color)"

// COLOR OBJECTS
export type ColorStatusType ={
    value: string,
    opacity: number
}
export const STATUS_SUCCESS:ColorStatusType = {
    value: '#1e9416',
    opacity: 0.15
}
export const STATUS_WARNING:ColorStatusType = {
    value: '#ffce00',
    opacity: 0.3
}
export const STATUS_ERROR:ColorStatusType = {
    value: '#fa0303',
    opacity: 0.3
}